/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Brand } from './Brand';
import {
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';
import type { CalibrationDataDtoCalibrationState } from './CalibrationDataDtoCalibrationState';
import {
    CalibrationDataDtoCalibrationStateFromJSON,
    CalibrationDataDtoCalibrationStateFromJSONTyped,
    CalibrationDataDtoCalibrationStateToJSON,
} from './CalibrationDataDtoCalibrationState';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { IotDeviceStateOfUse } from './IotDeviceStateOfUse';
import {
    IotDeviceStateOfUseFromJSON,
    IotDeviceStateOfUseFromJSONTyped,
    IotDeviceStateOfUseToJSON,
} from './IotDeviceStateOfUse';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { PtwRegistrationState } from './PtwRegistrationState';
import {
    PtwRegistrationStateFromJSON,
    PtwRegistrationStateFromJSONTyped,
    PtwRegistrationStateToJSON,
} from './PtwRegistrationState';
import type { QaEquipmentStateOfUse } from './QaEquipmentStateOfUse';
import {
    QaEquipmentStateOfUseFromJSON,
    QaEquipmentStateOfUseFromJSONTyped,
    QaEquipmentStateOfUseToJSON,
} from './QaEquipmentStateOfUse';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { WithSerialNumber } from './WithSerialNumber';
import {
    WithSerialNumberFromJSON,
    WithSerialNumberFromJSONTyped,
    WithSerialNumberToJSON,
} from './WithSerialNumber';

/**
 * 
 * @export
 * @interface UnicheckDeviceDto
 */
export interface UnicheckDeviceDto {
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof UnicheckDeviceDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckDeviceDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckDeviceDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckDeviceDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckDeviceDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof UnicheckDeviceDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof UnicheckDeviceDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnicheckDeviceDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnicheckDeviceDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnicheckDeviceDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof UnicheckDeviceDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof UnicheckDeviceDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckDeviceDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof UnicheckDeviceDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UnicheckDeviceDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckDeviceDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof UnicheckDeviceDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof UnicheckDeviceDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckDeviceDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {WithSerialNumber}
     * @memberof UnicheckDeviceDto
     */
    withSerialNumber?: WithSerialNumber;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {Brand}
     * @memberof UnicheckDeviceDto
     */
    brand1?: Brand;
    /**
     * 
     * @type {SingleDetectorConnectorType}
     * @memberof UnicheckDeviceDto
     */
    singleDetectorConnectorType?: SingleDetectorConnectorType;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof UnicheckDeviceDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof UnicheckDeviceDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof UnicheckDeviceDto
     */
    coordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {QaEquipmentStateOfUse}
     * @memberof UnicheckDeviceDto
     */
    state?: QaEquipmentStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckDeviceDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    serialNumber: string;
    /**
     * 
     * @type {PtwRegistrationState}
     * @memberof UnicheckDeviceDto
     */
    registrationState?: PtwRegistrationState;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    registrationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    deRegistrationTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    measurementDataChannelId?: string;
    /**
     * 
     * @type {IotDeviceStateOfUse}
     * @memberof UnicheckDeviceDto
     */
    iotDeviceStateOfUse?: IotDeviceStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof UnicheckDeviceDto
     */
    hasValidLicense?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    licenseExpirationDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    dpin: string;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    calibrationCertificateNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    calibrationDate?: string | null;
    /**
     * 
     * @type {CalibrationDataDtoCalibrationState}
     * @memberof UnicheckDeviceDto
     */
    calibrationState?: CalibrationDataDtoCalibrationState | null;
    /**
     * 
     * @type {string}
     * @memberof UnicheckDeviceDto
     */
    $type?: UnicheckDeviceDtoTypeEnum;
}


/**
 * @export
 */
export const UnicheckDeviceDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoUnicheckDeviceDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.UnicheckDeviceDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UnicheckDeviceDtoTypeEnum = typeof UnicheckDeviceDtoTypeEnum[keyof typeof UnicheckDeviceDtoTypeEnum];


/**
 * Check if a given object implements the UnicheckDeviceDto interface.
 */
export function instanceOfUnicheckDeviceDto(value?: unknown): value is UnicheckDeviceDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UnicheckDeviceDtoTypeEnum)[0];
}

export function UnicheckDeviceDtoFromJSON(json: any): UnicheckDeviceDto {
    return UnicheckDeviceDtoFromJSONTyped(json, false);
}

export function UnicheckDeviceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnicheckDeviceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'masterDeviceId': !exists(json, 'masterDeviceId') ? undefined : json['masterDeviceId'],
        'withSerialNumber': !exists(json, 'withSerialNumber') ? undefined : WithSerialNumberFromJSON(json['withSerialNumber']),
        'typeNumber': !exists(json, 'typeNumber') ? undefined : json['typeNumber'],
        'brand1': !exists(json, 'brand1') ? undefined : BrandFromJSON(json['brand1']),
        'singleDetectorConnectorType': !exists(json, 'singleDetectorConnectorType') ? undefined : SingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'deviceInterfaceType': !exists(json, 'deviceInterfaceType') ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'coordinateSystem': !exists(json, 'coordinateSystem') ? undefined : CoordinateSystemFromJSON(json['coordinateSystem']),
        'state': !exists(json, 'state') ? undefined : QaEquipmentStateOfUseFromJSON(json['state']),
        'isRegistrable': !exists(json, 'isRegistrable') ? undefined : json['isRegistrable'],
        'serialNumber': json['serialNumber'],
        'registrationState': !exists(json, 'registrationState') ? undefined : PtwRegistrationStateFromJSON(json['registrationState']),
        'registrationTime': !exists(json, 'registrationTime') ? undefined : json['registrationTime'],
        'deRegistrationTime': !exists(json, 'deRegistrationTime') ? undefined : json['deRegistrationTime'],
        'measurementDataChannelId': !exists(json, 'measurementDataChannelId') ? undefined : json['measurementDataChannelId'],
        'iotDeviceStateOfUse': !exists(json, 'iotDeviceStateOfUse') ? undefined : IotDeviceStateOfUseFromJSON(json['iotDeviceStateOfUse']),
        'hasValidLicense': !exists(json, 'hasValidLicense') ? undefined : json['hasValidLicense'],
        'licenseExpirationDate': !exists(json, 'licenseExpirationDate') ? undefined : json['licenseExpirationDate'],
        'dpin': json['dpin'],
        'calibrationCertificateNumber': !exists(json, 'calibrationCertificateNumber') ? undefined : json['calibrationCertificateNumber'],
        'calibrationDate': !exists(json, 'calibrationDate') ? undefined : json['calibrationDate'],
        'calibrationState': !exists(json, 'calibrationState') ? undefined : CalibrationDataDtoCalibrationStateFromJSON(json['calibrationState']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function UnicheckDeviceDtoToJSON(value?: UnicheckDeviceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'typeSpecification': value.typeSpecification,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isArchived': value.isArchived,
        'masterDeviceId': value.masterDeviceId,
        'withSerialNumber': WithSerialNumberToJSON(value.withSerialNumber),
        'typeNumber': value.typeNumber,
        'brand1': BrandToJSON(value.brand1),
        'singleDetectorConnectorType': SingleDetectorConnectorTypeToJSON(value.singleDetectorConnectorType),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value.deviceInterfaceType),
        'subCategory': QaEquipmentSubCategoryToJSON(value.subCategory),
        'coordinateSystem': CoordinateSystemToJSON(value.coordinateSystem),
        'state': QaEquipmentStateOfUseToJSON(value.state),
        'isRegistrable': value.isRegistrable,
        'serialNumber': value.serialNumber,
        'registrationState': PtwRegistrationStateToJSON(value.registrationState),
        'registrationTime': value.registrationTime,
        'deRegistrationTime': value.deRegistrationTime,
        'measurementDataChannelId': value.measurementDataChannelId,
        'iotDeviceStateOfUse': IotDeviceStateOfUseToJSON(value.iotDeviceStateOfUse),
        'hasValidLicense': value.hasValidLicense,
        'licenseExpirationDate': value.licenseExpirationDate,
        'dpin': value.dpin,
        'calibrationCertificateNumber': value.calibrationCertificateNumber,
        'calibrationDate': value.calibrationDate,
        'calibrationState': CalibrationDataDtoCalibrationStateToJSON(value.calibrationState),
        '$type': value.$type,
    });
}

